import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller'
import internalState from './internalState';
import {
  MakeReadyItemCellWrapper, Td, CustomBorderWrapper, FitRelativeWrapper,
  TagsDropdownBodyWrapper, MakeReadyTagsInputCellWrapper, Width200,
  CursorPointerWrapper, FlexCenterBetweenWrapper, P3, FlexBoxWrapper,
} from 'wrappers';
import { TagText, BorderlessInput, Icon, ClickableIcon } from 'atoms';
import { MagnifyingGlassSvg, CloseSvg } from 'components/icons';
import { escapedRegex } from 'utils';

export const definition = {
  name: 'TagsInputCell',
  controller: Controller,
  initialProps: ({ data, displayConfetti, selectedRow, makeReadyCategory, showCheckboxes }) => ({
    displayConfetti,
    data,
    selectedTagIds: data?.tags ? data.tags.map(t => t.id) : [],
    selectedRow,
    makeReadyCategory,
    showCheckboxes,
  }),
  props: internalState,
  elements: [
    {
      wrapper: FitRelativeWrapper,
      name: 'RelativeWrapper',
      renderIf: ({ selectedRow }) => !selectedRow,
      ref: ({ containerRef, isOpen }) => isOpen ? containerRef : null,
      elements: [
        {
          wrapper: MakeReadyItemCellWrapper,
          name: 'Selector',
          renderIf: ({ displayConfetti }) => !displayConfetti,
          isButton: true,
          bindings: ({ selectedTagIds, isOpen, containerRef, inputRef, showCheckboxes }) => ({ inputRef, selectedTagIds, isOpen, containerRef, showCheckboxes }),
          displayState: ({ showCheckboxes }) => ({ background: showCheckboxes ? '#F7F7F7' : '' }),
          elements: [
            {
              component: TagText,
              isListOf: { tag: ({ selectedTagIds, makeReadyCategory }) => selectedTagIds.map(id => makeReadyCategory?.tags.find(t => t.id === id)) },
              name: 'TagText',
              renderIf: ({ tag, showCheckboxes }) => !!tag && !showCheckboxes,
              displayState: ({ tag }) => ({ color: tag.color }),
              displayValue: ({ tag }) => tag.name ?? ''
            },
          ]
        },
        {
          wrapper: MakeReadyTagsInputCellWrapper,
          displayState: ({ isOpen }) => ({ isOpen, top: '0px', left: '1px', width: '200px', height: '350px' }),
          renderIf: ({ isOpen }) => isOpen,
          ref: ({ containerRef }) => containerRef,
          name: 'DropdownWrapper',
          elements: [
            {
              wrapper: Width200,
              name: 'Wrapper',
              elements: [
                {
                  wrapper: CustomBorderWrapper,
                  name: 'BorderWrapper',
                  displayState: ({ }) => ({ borderRadius: '8px', border: '1px solid #E3E3E3', background: '#FFFFFF' }),
                  elements: [
                    {
                      wrapper: CustomBorderWrapper,
                      displayState: ({ }) => ({ borderRadius: '8px 8px 0px 0px', border: `1px solid ${window?.settings?.primary_color ?? '#1DBD6B'}`, background: '#FFFFFF', padding: '8px' }),
                      name: 'SearchWrapper',
                      elements: [
                        {
                          wrapper: FlexCenterBetweenWrapper,
                          name: 'Wrapper',
                          ref: ({ inputRef }) => inputRef ?? null,
                          elements: [
                            {
                              component: BorderlessInput,
                              name: 'SearchInput',
                              renderIf: ({ selectedTagIds }) => selectedTagIds.length === 0,
                              displayState: ({ }) => ({ width: '114px', minWidth: '114px' }),
                              bindings: ({ searchVal }) => ({ value: searchVal, placeholder: "Search tag" })
                            },
                            {
                              wrapper: FlexBoxWrapper,
                              name: 'Tags',
                              renderIf: ({ selectedTagIds }) => selectedTagIds.length > 0,
                              elements: [
                                {
                                  component: wrap(TagText, FlexBoxWrapper),
                                  isListOf: { tag: ({ selectedTagIds, makeReadyCategory }) => selectedTagIds.map(id => makeReadyCategory?.tags.find(t => t.id === id)) },
                                  name: 'TagText',
                                  renderIf: ({ tag }) => !!tag,
                                  displayState: ({ tag }) => ({ color: tag.color }),
                                  displayValue: ({ tag }) => tag.name ?? ''
                                }
                              ]
                            },
                            {
                              component: ClickableIcon,
                              renderIf: ({ selectedTagIds }) => selectedTagIds.length > 0,
                              name: 'Close',
                              bindings: ({ }) => ({}),
                              displayValue: ({ }) => CloseSvg({ width: 22, height: 22 })
                            },
                            {
                              component: Icon,
                              name: 'Icon',
                              renderIf: ({ selectedTagIds }) => selectedTagIds.length === 0,
                              displayValue: ({ }) => MagnifyingGlassSvg({ width: 16, height: 16, color: '#9EACB0' })
                            }
                          ]
                        }
                      ]
                    },
                    {
                      wrapper: TagsDropdownBodyWrapper,
                      name: 'ListWrapper',
                      elements: [
                        {
                          wrapper: wrap(P3, CursorPointerWrapper),
                          name: 'TagWrapper',
                          isListOf: { tag: ({ makeReadyCategory, searchVal }) => makeReadyCategory?.tags ? makeReadyCategory.tags.filter(t => escapedRegex(searchVal).test(t.name)) : [] },
                          isButton: true,
                          bindings: ({ tag }) => ({ tag }),
                          elements: [
                            {
                              component: wrap(TagText, FlexBoxWrapper),
                              name: 'TagText',
                              displayState: ({ tag }) => ({ color: tag.color }),
                              displayValue: ({ tag }) => tag.name ?? ''
                            },
                          ]
                        },
                      ]
                    },
                  ]
                }
              ]
            },
          ]
        }
      ]
    }
  ]
}

export default wrap(ContainerComponent(definition), Td)